module.exports = __webpack_public_path__ + "img/lin.f6bcc1ce.png";